module.exports = __webpack_public_path__ + "static/media/prize@3x.4f646f89.png";